import { progressText } from "@/lib/reels";

export const ProgressBar = ({ progress, testId, compact = false }) => (
  <div className={compact ? "mt-1" : ""} data-testid={testId}>
    <div className="rs-progress">
      <div className="rs-progress-fill" style={{ transform: `scaleX(${Math.max(0.02, progress?.progress || 0)})` }} />
    </div>
    <p className={`rs-secondary mt-1 ${compact ? "text-[11px]" : "text-[13px]"}`} data-testid={`${testId}-text`}>
      {progressText(progress) || "Starting"}
    </p>
  </div>
);
